<template>
  <div class="categories-manager">
    <div v-for="(category, index) in value" :key="index" class="category-row">
      <template v-if="editingIndex === index">
        <input
          ref="editInput"
          type="text"
          class="form-control form-control-sm"
          v-model="editValue"
          @keyup.enter="saveEdit(index)"
          @keyup.esc="cancelEdit"
        >
        <div class="category-actions">
          <button type="button" class="btn btn-sm btn-light" @click="cancelEdit">
            <i class="fa fa-times"></i>
          </button>
          <button type="button" class="btn btn-sm btn-success" :disabled="!editValue.trim()" @click="saveEdit(index)">
            <i class="fa fa-check"></i>
          </button>
        </div>
      </template>
      <template v-else>
        <span class="category-name">{{ category }}</span>
        <div class="category-actions">
          <button type="button" class="btn btn-sm btn-light mr-1" @click="startEdit(index)">
            <i class="fa fa-pencil"></i>
          </button>
          <button type="button" class="btn btn-sm btn-light text-danger" @click="remove(index)">
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </template>
    </div>

    <div v-if="adding" class="category-row">
      <input
        ref="newInput"
        type="text"
        class="form-control form-control-sm"
        v-model="newValue"
        :placeholder="$tc('category.name', 1)"
        @keyup.enter="saveNew"
        @keyup.esc="cancelAdd"
      >
      <div class="category-actions">
        <button type="button" class="btn btn-sm btn-light" @click="cancelAdd">
          <i class="fa fa-times"></i>
        </button>
        <button type="button" class="btn btn-sm btn-success" :disabled="!newValue.trim()" @click="saveNew">
          <i class="fa fa-check"></i>
        </button>
      </div>
    </div>

    <button v-if="!adding && editingIndex === null" type="button" class="btn btn-sm btn-outline-primary mt-2" @click="startAdd">
      <i class="fa fa-plus mr-1"></i>{{ $t('category.add') }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      adding: false,
      editingIndex: null,
      newValue: '',
      editValue: ''
    }
  },
  methods: {
    startAdd () {
      this.newValue = ''
      this.adding = true
      this.$nextTick(() => this.$refs.newInput && this.$refs.newInput.focus())
    },
    cancelAdd () {
      this.adding = false
      this.newValue = ''
    },
    saveNew () {
      const trimmed = this.newValue.trim()
      if (!trimmed || this.value.includes(trimmed)) return
      this.$emit('input', [...this.value, trimmed])
      this.cancelAdd()
    },
    startEdit (index) {
      this.editingIndex = index
      this.editValue = this.value[index]
      this.$nextTick(() => this.$refs.editInput && this.$refs.editInput[0] && this.$refs.editInput[0].focus())
    },
    cancelEdit () {
      this.editingIndex = null
      this.editValue = ''
    },
    saveEdit (index) {
      const trimmed = this.editValue.trim()
      if (!trimmed) return
      const duplicate = this.value.some((c, i) => i !== index && c === trimmed)
      if (duplicate) return
      const updated = [...this.value]
      updated[index] = trimmed
      this.$emit('input', updated)
      this.cancelEdit()
    },
    remove (index) {
      this.$emit('input', this.value.filter((_, i) => i !== index))
    }
  }
}
</script>

<style scoped>
.category-row {
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 400px;
  padding: 6px 0;
  border-bottom: 1px solid #f0f0f0;
}
.category-row:last-child {
  border-bottom: none;
}
.category-name {
  flex-grow: 1;
  font-weight: 600;
}
.category-actions {
  display: flex;
  flex-shrink: 0;
  gap: 4px;
}
</style>
